import { createRouter, createWebHistory } from '@ionic/vue-router';
import { store } from '@/store';
import Tabs from '@/views/Tabs.vue'

const routes = [
  {
    path: '/splash',
    component: () => import('@/views/Splash.vue'),
  },
  {
    path: '/',
    component: Tabs,
    children: [
      {
        path: '',
        redirect: '/splash'
      },
      {
        path: 'home',
        component: () => import('@/views/Home/Home.vue'),
      },
      {
        path: 'home/:section',
        component: () => import('@/views/Home/Subsection.vue'),
      },
      {
        path: 'home/:section/:id',
        component: () => import('@/views/Home/SubsectionDetail.vue'),
      },
      {
        path: 'resources',
        component: () => import('@/views/Resources/Resources.vue'),
      },
      {
        path: 'resources/:id',
        component: () => import('@/views/Resources/ResourcesDetail.vue')
      },
      {
        path: 'bookmarks',
        component: () => import('@/views/Bookmarks/Bookmarks.vue')
      },
      {
        path: 'calendar',
        component: () => import('@/views/Calendar/Calendar.vue')
      },
      {
        path: 'settings',
        component: () => import('@/views/Settings/Settings.vue')
      },
        {
        path: '/privacy-policy',
        component: () => import('@/views/Policy.vue'),
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach(async (to, from, next) => {
  await store.getAppData();
  await store.updateBackButtonStatus(to, from);
  next();
});

router.afterEach(async (to) => {
  if (window.ga) {
    const pageName = to.fullPath;
    window.ga('set', 'page', pageName);
    window.ga('send', 'pageview');
  }
  
  // Set focus to the first focusable element inside ion-content
  setTimeout(() => {
    const ionContent = document.querySelector('ion-content');
    if (ionContent) {
      const focusableElements = ionContent.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), [button="true"], [role="button"]'
      );
      if (focusableElements.length > 0) {
        focusableElements[0].focus();
      }
    }
  }, 600); // Allow time for content to render
});

export default router
